import React from "react";
import { Container } from "react-bootstrap";

const LayoutContainer = ({ children }) => {
  return (
    <Container fluid style={{ maxWidth: "1400px", margin: "0 auto", position: "relative", zIndex: 1 }}>
      <div>{children}</div>
    </Container>
  );
};

export default LayoutContainer;
